<cst-tile-grid
  [fetchDataCallback]="fetchData"
  [canTileClick]="canUpdate.bind(this)"
  [tileClick]="onUpdate.bind(this)"
  [actions]="actions"
></cst-tile-grid>
